var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { Heading, Link } from "@riseart/common";
import { artActionHeadingCls, artActionHeadingTitleCls, artActionHeadingLinksCls, artActionAuthorCls, artActionAuthorHeadingCls } from "./Action.less";
var ArtActionHeading = /* @__PURE__ */ __name(function ArtActionHeading2(_ref) {
  var title = _ref.title, _ref$links = _ref.links, links = _ref$links === void 0 ? null : _ref$links, _ref$artistUrl = _ref.artistUrl, artistUrl = _ref$artistUrl === void 0 ? null : _ref$artistUrl, artistName = _ref.artistName, _ref$translations = _ref.translations, translations = _ref$translations === void 0 ? {} : _ref$translations;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    className: artActionHeadingCls
  }, /* @__PURE__ */ React.createElement(Heading, {
    tag: "h2",
    className: artActionHeadingTitleCls
  }, title), links ? /* @__PURE__ */ React.createElement("span", {
    className: artActionHeadingLinksCls
  }, links) : null), artistName && /* @__PURE__ */ React.createElement("div", {
    className: artActionAuthorCls
  }, translations.by, " ", /* @__PURE__ */ React.createElement(Heading, {
    tag: "h3",
    level: "5",
    className: artActionAuthorHeadingCls
  }, artistUrl ? /* @__PURE__ */ React.createElement(Link, {
    to: artistUrl,
    title: artistName
  }, artistName) : artistName)));
}, "ArtActionHeading");
export {
  ArtActionHeading
};
